
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import UpdateIcon from '@mui/icons-material/Update';
import CelebrationIcon from '@mui/icons-material/Celebration';
import { Person } from '@mui/icons-material';
import TtkList from './TtkList';
const LiveMusicBandTTK = ({ data }) => {
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <UpdateIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Duration :</b>&nbsp;<span>{data?.duration}</span></p>
                        </div>
                        {/* <div className='col-md-3'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Travel Preference:</b>&nbsp;<TtkList data={data?.travelPreference} /></p>
                        </div> */}
                        <div className='col-md-3'>
                            <p> <LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Types of Artist :</b>&nbsp;<TtkList data={data?.typeOfArtist} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Areas Of Services :</b>&nbsp;<TtkList data={data?.areaOfWork} /></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>No. of Events Covered :</b>&nbsp;<span>{data?.coveredOfEvent}</span></p>
                        </div>

                        <div className='col-md-3'>
                            <p> <Person sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Team Size :</b>&nbsp;<span>{data?.noOfTeam}</span></p>
                        </div>
                        <div className='col-md-6'>
                            <p ><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Event Types :</b>&nbsp;<TtkList data={data?.eventTypeBand} /></p>
                        </div>

                    </div>
                </div>

            </div>
        </>
    )
}

export default LiveMusicBandTTK